import { render, staticRenderFns } from "./LessonEdit.vue?vue&type=template&id=1885ddc7"
import script from "./LessonEdit.vue?vue&type=script&lang=js"
export * from "./LessonEdit.vue?vue&type=script&lang=js"
import style0 from "./LessonEdit.vue?vue&type=style&index=0&id=1885ddc7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports